var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":{ name: 'login' }}},[_c('img',{staticClass:"company-logo",attrs:{"alt":_vm.appName,"src":_vm.logoSrc}})]),_c('p',{staticClass:"p-t-10 login-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }